var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrivateAlbumDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "78px",
    viewBox: "0 0 95 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPrivateAlbumDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-album-access-empty-state",
    transform: "translate(-640.000000, -518.000000)",
    fill: "#C2C2C2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640,518 L735,518 L735,596 L640,596 L640,518 Z M643,521 L643,593 L732,593 L732,521 L643,521 Z M708.567195,553.914214 L723.875508,569.763282 L725,570.927495 L722.751017,573.255922 L721.626525,572.091709 L706.318212,556.242641 L697.901075,564.957107 L697.435295,565.43934 L704.262161,572.507359 L705.386652,573.671573 L703.137669,576 L702.013177,574.835786 L677.693326,549.656854 L653.373475,574.835786 L652.248983,576 L650,573.671573 L651.124492,572.507359 L676.568835,546.164214 L677.693326,545 L679.94231,547.328427 L695.186312,563.110913 L695.652092,562.62868 L705.19372,552.75 L706.318212,551.585786 L708.567195,553.914214 Z M711,542.5 C706.857864,542.5 703.5,539.142136 703.5,535 C703.5,530.857864 706.857864,527.5 711,527.5 C715.142136,527.5 718.5,530.857864 718.5,535 C718.5,539.142136 715.142136,542.5 711,542.5 Z M711,541.5 C714.589851,541.5 717.5,538.589851 717.5,535 C717.5,531.410149 714.589851,528.5 711,528.5 C707.410149,528.5 704.5,531.410149 704.5,535 C704.5,538.589851 707.410149,541.5 711,541.5 Z",
    id: "icPrivateAlbumDsk"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivateAlbumDsk);
export default __webpack_public_path__ + "static/media/icPrivateAlbumDsk.9fc6549581cb782cec09b5d5d106900e.svg";
export { ForwardRef as ReactComponent };